import React from "react";
import styles from "../styles/Toolbar.module.css";

export default function Toolbar({
  currentMode,
  setMode,
  currentAccent,
  setAccent,
  pageSize,
  setPageSize,
  onOpenPrint,
}) {
  const swatches = ["#FF4D00", "#00C2FF", "#C8FF00", "#BF5FFF", "#FF3D7F", "#00D9A5"];

  return (
    <div id="toolbar" className={styles.toolbar}>
      <div className={styles.brand}>Nathan Martins · CV</div>

      <div className={styles.modeToggle}>
        <div
          className={`${styles.modeOpt} ${currentMode === "styled" ? styles.on : ""}`}
          onClick={() => setMode("styled")}
        >
          ✦ Styled
        </div>
        <div
          className={`${styles.modeOpt} ${currentMode === "minimal" ? styles.on : ""}`}
          onClick={() => setMode("minimal")}
        >
          Minimal
        </div>
      </div>

      <div className={styles.colorSwatches} title="Theme color">
        {swatches.map((color) => (
          <div
            key={color}
            className={`${styles.swatch} ${currentAccent === color ? styles.active : ""}`}
            style={{ background: color }}
            onClick={() => setAccent(color)}
          />
        ))}
      </div>

      <select
        id="page-size-select"
        value={pageSize}
        className={styles.select}
        onChange={(e) => setPageSize(e.target.value)}
        title="Page size for PDF"
      >
        <option value="A4">A4</option>
        <option value="Letter">Letter</option>
        <option value="A3">A3</option>
      </select>

      <button className={styles.tbBtn} onClick={onOpenPrint}>
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          width="13"
          height="13"
        >
          <rect x="2" y="7" width="20" height="14" rx="2" />
          <path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" />
          <line x1="12" y1="12" x2="12" y2="16" />
          <line x1="10" y1="14" x2="14" y2="14" />
        </svg>
        Print / PDF
      </button>
    </div>
  );
}
